import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="lookup-search"
//
// Handles debounced search + instant per-page changes for the LookupTableComponent.
// The form this controller is attached to must have data-turbo-frame pointing at
// the table Turbo Frame so only the table updates (not the full page).
//
// Targets:
//   input — the search text/search field
//
// Actions wired in the template:
//   input->lookup-search#debounce   (on the search input)
//   change->lookup-search#submitNow (on the per-page select)
var _default = /*#__PURE__*/function (_Controller) {
  function _default() {
    _classCallCheck(this, _default);
    return _callSuper(this, _default, arguments);
  }
  _inherits(_default, _Controller);
  return _createClass(_default, [{
    key: "connect",
    value: function connect() {
      this._timeout = null;
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      clearTimeout(this._timeout);
    }

    // Debounced: waits 350 ms after the user stops typing before submitting.
  }, {
    key: "debounce",
    value: function debounce() {
      var _this = this;
      clearTimeout(this._timeout);
      this._timeout = setTimeout(function () {
        _this._submit();
      }, 350);
    }

    // Immediate submit — used for the per-page <select> onChange.
  }, {
    key: "submitNow",
    value: function submitNow() {
      clearTimeout(this._timeout);
      this._submit();
    }
  }, {
    key: "_submit",
    value: function _submit() {
      // requestSubmit() triggers a native submit event which Turbo intercepts
      // and handles as a Turbo Frame request (because the form has data-turbo-frame).
      this.element.requestSubmit();
    }
  }]);
}(Controller);
_defineProperty(_default, "targets", ['input']);
export { _default as default };